import Vue from 'vue';
import Component from 'vue-class-component';
import SidebarComponent from '@/components/sidebar/sidebar.component.vue';
import HeaderComponent from '@/components/header/header.component.vue';
import LoaderComponent from '@/components/loader/loader.component.vue';

import CandidateService from '@/core/services/candidate.service.ts';
import SidebarService from '@/core/services/sidebar.service.ts';

@Component({
  components: {
    SidebarComponent,
    HeaderComponent,
    LoaderComponent
  }
})
export default class CreateEvaluatedComponent extends Vue {

    candidateService: any = new CandidateService();
    sidebarService: any = new SidebarService();
    isLoading: boolean = false;
    isSuccess: boolean = false;
    isErrorServer: boolean = false;
    genericErr: any = [];
    candidateList: any = [];
    companyList: any = [];
    jobList: any = [];
    name: string = "";
    surname: string = "";
    birthdate: string = "";
    email: string = "";
    password: string = "";
    confirm_password: string = "";
    country: string = "";
    companies: string = "";
    jobs: string = "";
    job: string = "";
    manuallyPassword: string = "";


    mounted (){
      const _ = this;
      _.getCompanies();
      _.getJobs();
    }

    closeSidebar(){
      const _ = this;
      _.sidebarService.close();
    }

    getCompanies(){
      const _ = this;
      _.isLoading = true;
      _.candidateService.getCompanies().then((data: any) => {
        _.companyList = data['data'].companies;
        setTimeout(() => {
          _.isLoading = false;
        }, 1500)
      })
      .catch((err: any) => {
        _.isLoading = false;
      })
    }

    getJobs(){
      const _ = this;
      _.isLoading = true;
      _.candidateService.getJobs().then((data: any) => {
        _.jobList = data['data'].jobs;
        console.log(data);
        setTimeout(() => {
          _.isLoading = false;
        }, 1500)
      })
      .catch((err: any) => {
        _.isLoading = false;
      })
    }

    create(){
      const _ = this;
      let candidate = {
        name: _.name,
        surname: _.surname,
        birthdate: _.birthdate,
        email: _.email,
        password: _.password,
        confirm_password: _.confirm_password,
        country: _.country,
        jobId: _.jobs,
        companyId: _.companies
      };
      console.log(candidate);
      _.isLoading = true;
      _.candidateService.create(candidate).then((data: any) => {
        console.log(data);
        _.isSuccess = true;
        _.isErrorServer = false;
        setTimeout(() => {
          _.isLoading = false;
          _.$router.push('/');
        }, 2000)
      })
      .catch((err: any) => {
        _.isErrorServer = true;
        setTimeout(() => {
          _.isLoading = false;
        }, 2000)
      })
    }

    assingCompanies(user_id, company_id){
      console.log(user_id, company_id);
      const _ = this;
      _.candidateService.assingCompanies(user_id, company_id).then((data: any) => {
        console.log(data);
      })
    }

    validations(name = '', surname = '', email = '', password = '',  confirm_password = ''){
      const _ = this;
      _.genericErr = [];
      let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if(name == ''){
        _.genericErr.push("Por favor escribe tu nombre");
      }
      if(surname == ''){
        _.genericErr.push("Por favor escribe tu apellido");
      }
      if(!emailRegex.test(email.toLowerCase()) && email != ''){
        _.genericErr.push("Correo invalido");
      }
      if(email == ''){
        _.genericErr.push("Por favor escribe un correo");
      }
      if(password == ''){
        _.genericErr.push("Por favor escribe una contraseña");
      }
      if(password.length < 3 && password != ''){
        _.genericErr.push("La constraseña debe tener minimo 3 caracteres");
      }
      if(password != confirm_password){
        _.genericErr.push("Las constraseñas no coinciden");
      }
      _.genericErr.length > 0 ? false : _.create()
    }
  }
